export default "__VITE_ASSET__F5oBL50___"